<template>
    <div class="wrap-input" :class="customClass">
        <label
            class="label"
            v-if="showLabel"
            :class="{
                error: !isFirstSave && isShowErrorLbl && !errorInfo.isValid
            }"
            :for="id"
            >{{ label }}</label
        >
        <div class="input-box">
            <input
                :id="id"
                type="tel"
                class="input-field"
                :class="{
                    error:
                        (!isFirstSave &&
                            isShowErrorLbl &&
                            !errorInfo.isValid) ||
                        (content && content.length != 12 && content.length > 0)
                }"
                :maxlength="maxLength"
                :readonly="readOnly"
                :disabled="disabled"
                v-model="content"
                @input="onChange()"
            />
            <span
                v-if="isShowErrorLbl"
                class="placeholder"
                :class="{
                    error: !isFirstSave && isShowErrorLbl && !errorInfo.isValid
                }"
                v-show="!content"
            >
                กรุณากรอกเบอร์โทรศัพท์</span
            >
        </div>
        <div
            class="error-text"
            v-if="isShowErrorLbl"
            v-show="
                (!isFirstSave && !errorInfo.isValid) ||
                    (content && content.length != 12 && content.length > 0)
            "
        >
            {{ errorInfo.msg }}
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (required) Validation status. example : { isValid: true, msg: '',}
 * @property {string} delimeter (optional) Character seperate number.
 * @property {boolean} blockAutoComplete (optional) Block borwser auto complete field.
 * @property {string} addClass (optional) Add css class
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: "ContactNumber",
    props: {
        //v-model
        value: String,
        //propss
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        delimeter: String,
        blockAutoComplete: Boolean,
        addClass: String,
        disabled: Boolean,
        showLabel: Boolean
    },
    data: function() {
        return {
            id: "",
            label: "",
            placeholder: "",
            content: this.value,
            minLength: 0,
            maxLength: 0,
            readOnly: true,
            customClass: ""
        };
    },
    mounted: function() {
        this.id = this.inputId;
        this.label = this.inputLbl.name;
        this.placeholder = this.inputLbl.placeholder;
        this.minLength = this.inputMinLength || null;
        this.maxLength = Util.isEmptyStr(this.delimeter) ? 10 : 12;
        this.customClass = this.addClass;
        this.onChange();
        this.validateInput();

        this.readOnly = this.blockAutoComplete;
        setTimeout(() => {
            this.readOnly = false;
        }, 500);
    },
    methods: {
        validateInput: function() {
            if (!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = "";
            //Required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if (this.inputLbl.too_short && this.content < this.maxLength) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(
                    this.inputLbl.too_short,
                    this.maxLength
                );
                return;
            }
            //InValid format
            if (this.inputLbl.invalid) {
                // Delete delimeter 3 time without Regx.
                var contactnumber = this.content.replace(this.delimeter, "");
                contactnumber = contactnumber.replace(this.delimeter, "");
                contactnumber = contactnumber.replace(this.delimeter, "");

                if (!Vue.validator.validateContactNumber(contactnumber)) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.invalid;
                    return;
                }
            }
        },
        onChange: function() {
            var input = this.content || "";
            input = input.replace(Vue.RegExp.emoji, "");
            input = input.replace(/^[^0].*/, "");
            input = input.replace(Vue.RegExp.notNumber, "");

            this.validateInput();

            if (Util.isEmptyStr(this.delimeter)) {
                this.content = input;
                this.$emit("input", input);
            } else {
                var n1, n2, n3;
                var formatted = input;
                if (input.length <= 3) {
                    // do nothing
                } else if (input.length <= 6) {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    input = n1 + this.delimeter + n2;
                } else {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    n3 = input.substr(6);
                    input = n1 + this.delimeter + n2 + this.delimeter + n3;
                }

                this.content = input;
                this.$emit("input", formatted);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/Input/Text.scss";
.wrap-input {
    @extend %input-base;
    font-family: "DBHeaventRegular";
    .label {
        font-size: 1.5rem;
    }
    .error-text {
        font-family: "DBHeaventRegular";
        font-size: 1.5rem;
        margin: 0.25rem 0;
    }
    .input-box {
        font-family: "DBHeaventRegular";
        .input-field {
            font-size: 1.5rem;
            color: #666666;
        }
        .placeholder {
            font-size: 1.5rem;
            color: #65513e;
        }
    }
}
.wrap-input .input-box .error.input-field {
    color: #e73030;
    font-family: "DBHeaventRegular";
    font-size: 1.5rem;
}
</style>
